import React, { ReactElement } from 'react';
import { Text } from 'rsuite';
import Notice from '../../user-feedback/Notice';
import { TaxLicensesTable } from './TaxLicensesTable';
import {
  ExtendedPaymentPeriod,
  PaymentPeriod,
  PeriodLicense,
} from '../../../types/tax';
import { EndpointData } from '../../../types/store';

interface TaxPropertySelectionProps {
  licensesPerPeriod: Record<string, EndpointData<PeriodLicense>>;
  periodsToShow: ExtendedPaymentPeriod[];
  permitType: string;
  selectAll: (period: PaymentPeriod, isSelected: boolean) => void;
  selectLicense: (licenseNum: string, period: PaymentPeriod) => void;
  selectedLicenses: Record<string, Set<string>>;
}

export const TaxPropertySelection = ({
  licensesPerPeriod,
  periodsToShow,
  permitType,
  selectAll,
  selectLicense,
  selectedLicenses,
}: TaxPropertySelectionProps): ReactElement => {
  if (!periodsToShow.length) {
    return (
      <div className="mt-24 mb-24">
        <Notice
          message="No Payment periods Selected"
          type="info"
        />
      </div>
    );
  }

  return (
    <>
      {periodsToShow.map((period) => (
        <div
          className="mb-24"
          key={`tax_period_${period.startDate}_${period.endDate}`}
        >
          <Text
            as="h2"
            className="text-bold  header-text-h4 mb-16"
          >
            {period.name}
          </Text>
          <TaxLicensesTable
            licenses={licensesPerPeriod[period.startDate]?.data || []}
            loading={licensesPerPeriod[period.startDate]?.loading}
            period={period}
            permitType={permitType}
            selectAll={selectAll}
            selectLicense={selectLicense}
            selectedLicenses={selectedLicenses[period.startDate]}
          />
        </div>
      ))}
    </>
  );
};
